export default "__VITE_ASSET__CYGGapm4__"